<template>
    <div class="flex py-4 px-3 flex-wrap">
      <div class="w-full md:w-5/12 justify-start flex flex-wrap">
        <div class="table__search-input-wrapper search_mod">
          <span class="pr-2 opacity-50"><search-icon /> </span>
  
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="searchString"
          />
          <img
            @click="showFilterModal = true"
            class="cursor-pointer"
            src="@/assets/images/icons/search.svg"
            alt="search icon"
          />
        </div>
      </div>
      <div class="date-picker  action_contain">
        <p class="price_contain">
            <span @click="$emit('openPriceInfo')" class="price_item">
                <img src="../icons/PriceIcon.svg" class="mr-2"/>
                Pricing & Tier Info
            </span>
            <span class="mx-3">Current Tier:
                {{ currentTier.currentTier ||  "N/A" }} {{ currentTier.changes || '0' }}%</span>
        </p>
       <button
       @click="$emit('openmodal')"
       class=" rounded bg-primary-yellow px-3 py-2">
        View Tier History
       </button>
      </div>
        <div class="w-full">
            <EarnPayoutFilterTable
            @getStatusProps="getStatusProps"
            :show-modal="showFilterModal"
            @close-modal="showFilterModal = false"
          />
        </div>
    </div>
  </template>
  
  <script>
  import EarnPayoutFilterTable from "../modals/EarnPayoutFilterTable.vue";
  export default {
    props:{
        openPriceInfo: {
            type: Function
        },
        currentTier:{
          type: Object
        }
    },
    components: {
      EarnPayoutFilterTable,
    },
    computed: {
      sortProps() {
        return {
          startDate: this.startDate || null,
          endDate: this.endDate || null,
          searchString: this.searchString,
        };
      },
    },
    methods: {
      getStatusProps(val){
         this.$emit('setStatusChanges', val)
      }
    },
    watch: {
      sortProps() {  
        if(this.startDate < this.endDate){
          this.$emit("setQueryparams", this.sortProps);
        }
        else if(!this.startDate && !this.endDate){
          this.$emit("setQueryparams", this.sortProps);
        }
      },
    },
    // setQueryparams
    data() {
      return {
        showFilterModal: false,
        startDate: "",
        endDate: "",
        searchString: "",
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .action_contain{
    @apply w-full md:w-7/12 flex items-center md:justify-end md:flex-nowrap flex-wrap;
  }
  .price_item{
    @apply text-blue-600 px-2 border-l-[1px] border-l-gray-300 flex items-center mb-2 sm:mb-0 cursor-pointer
  }
  .price_contain{
    @apply flex items-center md:w-auto w-full text-[15px] my-3 md:my-0 flex-wrap
  }
  .search_mod{
    @apply md:w-[400px] w-full opacity-75
  }
</style>
  